const state = {
    isIndonesia : true,
    negara: "Indonesia",
    namaProvinsi: "",
    kodeProvinsi: "",
    filter: "",
    zoomLevel: 8,
    center : {
        lat: '',
        lng: ''
    }
}

const getters = {

}

const mutations = {
    UPDATE_IS_INDONESIA(state, payload){
        state.isIndonesia = payload
    },
    UPDATE_NAMA_PROVINSI(state, payload){
        state.namaProvinsi = payload
    },
    UPDATE_KODE_PROVINSI(state, payload){
        state.kodeProvinsi = payload
    },
    SETTING_CENTER(state, payload){
        state.center = payload
    },
    SETTING_FILTER(state, payload){
        state.filter = payload
    },
    SETTING_ZOOM_LEVEL(state, payload){
        state.zoomLevel = payload;
    }
}

const actions = {
    updateIsIndonesia({commit}, payload){
        commit('UPDATE_IS_INDONESIA', payload)
    },
    updateNamaProvinsi({commit}, payload){
        commit('UPDATE_NAMA_PROVINSI', payload)
    },
    settingCenter({commit}, payload){
        commit('SETTING_CENTER', payload)
    },
    updateKodeProvinsi({commit}, payload){
        commit('UPDATE_KODE_PROVINSI', payload)
    },
    settingFilter({commit}, payload){
        commit('SETTING_FILTER', payload)
    },
    settingZoomLevel({commit}, payload){
        commit('SETTING_ZOOM_LEVEL', payload)
    }
}

export default{
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}